let isInitialLoad = true;

document.addEventListener('turbo:load', function() {
  if (typeof window.dataLayer !== 'undefined') {
    if (isInitialLoad) {
      isInitialLoad = false;
    } else {
      window.dataLayer.push({
        'event': 'pageview',
        'page': {
          'url': window.location.href,
          'title': document.title,
          'path': window.location.pathname
        }
      });
    }
  }
});
